import { DefaultTheme } from 'styled-components';
import staticTheme from './default';
import { getAntdTokens } from './getThemeAntd';

const antdTokens = getAntdTokens('dark');

const darkTheme: DefaultTheme = {
    colors: {
        backgroundColor: 'black',
        black: '#000',
        green: '#12776e',
        translucentGreen: '#12776ebf',
        white: '#fff',
        accentColor: '#4b7cf3',
        secondaryColor: '#78a3ff',
        selectedColor: '#78a3ff',
        componentBackground: '#141414',
        tableHeaderBackground: '#1d1d1d',
        lightGrey: '#e4e9f0',
        fail: '#f5222e',
        sucess: '#41b883',

        darkFont: '#141322',
        lightFont: '#ffffff',
        font: '#FFFFFF',

        /**
         * ANTD
         */
        antdBorder: antdTokens.colorBorder,
        antdBorderSecondary: antdTokens.colorBorderSecondary,
        antdBackground: antdTokens.colorBgContainer,
        antdText: antdTokens.colorText,
        antdTextSecondary: antdTokens.colorTextSecondary,
        antdPrimary: antdTokens.colorPrimary,
        colorBgContainer: antdTokens.colorBgContainer,
        colorBgElevated: antdTokens.colorBgElevated,
        colorPrimaryHover: antdTokens.colorPrimaryHover,
        colorTextTertiary: antdTokens.colorTextTertiary,
        colorTextPlaceholder: antdTokens.colorTextPlaceholder,
        colorTextDisabled: antdTokens.colorTextDisabled,
        colorTextLightSolid: antdTokens.colorTextLightSolid,
        colorFillAlter: antdTokens.colorFillAlter,
        colorFillTertiary: antdTokens.colorFillTertiary,
        colorBgContainerDisabled: antdTokens.colorBgContainerDisabled,
        colorPrimaryBg: antdTokens.colorPrimaryBg,
        colorPrimaryBgHover: antdTokens.colorPrimaryBgHover,
        colorPrimaryBorder: antdTokens.colorPrimaryBorder,
        colorPrimaryText: antdTokens.colorPrimaryText,
        colorSuccess: antdTokens.colorSuccess,
        colorSuccessBg: antdTokens.colorSuccessBg,
        colorSuccessText: antdTokens.colorSuccessText,
        colorWarning: antdTokens.colorWarning,
        colorWarningBg: antdTokens.colorWarningBg,
        colorWarningBorder: antdTokens.colorWarningBorder,
        colorWarningText: antdTokens.colorWarningText,
        colorError: antdTokens.colorError,
        colorErrorBg: antdTokens.colorErrorBg,
        colorErrorBorder: antdTokens.colorErrorBorder,
        colorErrorText: antdTokens.colorErrorText,
        boxShadowSecondary: antdTokens.boxShadowSecondary,
        infoSurfaceBg: '#1a2233',
        infoSurfaceBorder: '#2a3a5c',
        infoSurfaceButtonBg: '#22304a',
    },
    ...staticTheme,
    borderRadius: {
        default: `${antdTokens.borderRadius}px`,
    },
    theme: 'dark',
};

export default darkTheme;
